import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChargedWithFelony = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Bank.2",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_15462",
		"data-name": "Group 15462",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11903",
				"data-name": "Path 11903",
				d: "M4,18V9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11904",
				"data-name": "Path 11904",
				d: "M20,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11905",
				"data-name": "Path 11905",
				d: "M8,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11906",
				"data-name": "Path 11906",
				d: "M12,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11907",
				"data-name": "Path 11907",
				d: "M16,9v9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11908",
				"data-name": "Path 11908",
				d: "M12,6.275a.124.124,0,0,0-.124.125.125.125,0,0,0,.25,0A.127.127,0,0,0,12,6.275",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11909",
				"data-name": "Path 11909",
				d: "M21.5,9H2.5V6.361L12,3l9.5,3.361Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11910",
				"data-name": "Path 11910",
				d: "M21,18H3L2,19v2H22V19Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_11911",
		"data-name": "Path 11911",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgChargedWithFelony;
